<div class="course-intensity-selector">
  <div class="course-intensity-selector__title" i18n>Choose the intensity of your course</div>
  @if (coursesWithHours().length > 0) {
  <div class="course-intensity-selector__course-cards">
    @for (course of coursesWithHours(); track course.code) {
    <lx-course-selection-card
      [title]="course.shortName"
      [subtitle]="(course.lessonHours | lxLocalizeAndPluralizePeriod : DurationUnitEnum.HOURS : true) + '/' + (DurationUnitEnum.DAYS | lxUnitLabel)"
      [option]="course"
      [selectedOption]="selectedCourseFromList()"
      (selectedOptionChanged)="onSelectCourse($event)"
      (keydown.enter)="onSelectCourse(course)"
      [attr.data-qa]="'course-card-' + course.code"
    >
    </lx-course-selection-card>
    }
  </div>
  } @else {
  <div class="course-intensity-selector__placeholder" i18n>Loading courses...</div>
  }
  <a
    class="course-intensity-selector__compare-link"
    (click)="onCompareCourses()"
    (keydown.enter)="onCompareCourses()"
    tabindex="0"
    i18n
    data-qa="compare-courses-link"
  >
    Compare our online courses
  </a>
</div>
